import React from 'react';

interface RefundTermsProps {
    className?: string;
}

const RefundTerms: React.FC<RefundTermsProps> = ({ className = '' }) => {
    return (
        <div className={`bg-blue-50 border border-blue-200 rounded-lg p-4 ${className}`}>
            <h3 className="text-lg font-semibold text-blue-900 mb-3">Refund Policy</h3>
            <div className="space-y-2 text-sm text-blue-800">
                <div>
                    <strong>Time Limit:</strong> Refunds must be requested within <strong>7 days</strong> of payment completion and before the seller has been paid out.
                </div>
                <div>
                    <strong>Processing Fee:</strong> A <strong>10% processing fee</strong> will be retained by the platform. This fee is deducted from the refund amount.
                </div>
                <div>
                    <strong>Shipping Costs:</strong> Shipping costs are only refunded if the item has <strong>not been shipped</strong>. Once a shipping label is generated, shipping costs are not refundable.
                </div>
                <div>
                    <strong>After Time Limit:</strong> After 7 days or once the seller has been paid out, refunds cannot be processed through the platform. Please contact the seller directly.
                </div>
                <div>
                    <strong>Approval Required:</strong> All refund requests require admin approval before processing.
                </div>
            </div>
        </div>
    );
};

export default RefundTerms;

